export const getPathName = (currentUser, path, adminPath = '/admin/admincentre') => {
  if (currentUser.IsAdmin && window.location.href.indexOf('admin/admincentre') > 0) {
    return adminPath + path
  }
  return path
}




// WEBPACK FOOTER //
// ./src/utils/getPathName.js